import { useRef, useEffect } from "react";

const WW_SECTORS = [
  { label: "×1",       color: "#388e3c" }, { label: "×2",       color: "#1976d2" },
  { label: "×1",       color: "#388e3c" }, { label: "БАНКРОТ",  color: "#c62828" },
  { label: "×1",       color: "#388e3c" }, { label: "×3",       color: "#f57c00" },
  { label: "ПРОПУСТИ", color: "#7b1fa2" }, { label: "×1",       color: "#388e3c" },
  { label: "×2",       color: "#1976d2" }, { label: "ДЖОКЕР",   color: "#f9a825" },
  { label: "×1",       color: "#388e3c" }, { label: "×3",       color: "#f57c00" },
  { label: "БАНКРОТ",  color: "#c62828" }, { label: "×1",       color: "#388e3c" },
  { label: "ПРОПУСТИ", color: "#7b1fa2" }, { label: "×1",       color: "#388e3c" },
];

// ── Колесо (canvas, анимация через RAF) ──────────────────────────────────────
function WheelSVG({ spinResult, spinKey }) {
  const canvasRef = useRef(null);
  const stateRef  = useRef({ angle: 0, targetAngle: 0, spinning: false, prevKey: null, speed: 0 });
  const rafRef    = useRef(null);
  const SIZE = 460, cx = 230, cy = 230, R = 205;
  const N = WW_SECTORS.length, DEG = 360 / N;

  function drawWheel(angle) {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, SIZE, SIZE);

    WW_SECTORS.forEach((s, i) => {
      const a1 = (angle + i * DEG - 90) * Math.PI / 180;
      const a2 = (angle + (i + 1) * DEG - 90) * Math.PI / 180;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.arc(cx, cy, R, a1, a2);
      ctx.closePath();
      ctx.fillStyle = s.color;
      ctx.fill();
      ctx.strokeStyle = "#111";
      ctx.lineWidth = 1.5;
      ctx.stroke();

      const ma = (a1 + a2) / 2;
      const tx = cx + R * 0.64 * Math.cos(ma);
      const ty = cy + R * 0.64 * Math.sin(ma);
      ctx.save();
      ctx.translate(tx, ty);
      ctx.rotate(ma + Math.PI / 2);
      ctx.textAlign = "center";
      const fs = s.label.length > 5 ? 11 : s.label.length > 3 ? 13 : 17;
      ctx.font = `bold ${fs}px 'Fredoka One', sans-serif`;
      ctx.fillStyle = "#fff";
      ctx.shadowColor = "#000";
      ctx.shadowBlur = 4;
      ctx.fillText(s.label, 0, 0);
      ctx.restore();
    });

    // Centre
    ctx.beginPath();
    ctx.arc(cx, cy, 22, 0, Math.PI * 2);
    ctx.fillStyle = "#111";
    ctx.fill();
    ctx.strokeStyle = "#fff";
    ctx.lineWidth = 3;
    ctx.stroke();

    // Arrow
    ctx.beginPath();
    ctx.moveTo(cx, 6);
    ctx.lineTo(cx - 16, 38);
    ctx.lineTo(cx + 16, 38);
    ctx.closePath();
    ctx.fillStyle = "#ffe600";
    ctx.fill();
    ctx.strokeStyle = "#000";
    ctx.lineWidth = 2.5;
    ctx.stroke();
  }

  function animate() {
    const st = stateRef.current;
    if (!st.spinning) return;
    const diff = st.targetAngle - st.angle;
    if (Math.abs(diff) < 0.05) {
      st.angle = st.targetAngle;
      st.spinning = false;
      drawWheel(st.angle);
      return;
    }
    st.angle += diff * 0.035;
    drawWheel(st.angle);
    rafRef.current = requestAnimationFrame(animate);
  }

  useEffect(() => { drawWheel(stateRef.current.angle); }, []); // eslint-disable-line

  useEffect(() => {
    if (!spinResult || !spinKey) return;
    const st = stateRef.current;
    const idx = spinResult.sector_idx;
    const sectorCenter = idx * DEG + DEG / 2;
    const currentNorm  = ((st.angle % 360) + 360) % 360;
    const targetNorm   = ((-sectorCenter) % 360 + 360) % 360;
    let delta = targetNorm - currentNorm;
    if (delta < 0) delta += 360;
    const extraRounds = 4 + Math.floor(Math.random() * 3);
    st.targetAngle = st.angle + extraRounds * 360 + delta;
    st.spinning = true;
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(animate);
  }, [spinKey]); // eslint-disable-line

  useEffect(() => {
    return () => { if (rafRef.current) cancelAnimationFrame(rafRef.current); };
  }, []);

  return (
    <canvas ref={canvasRef} width={SIZE} height={SIZE}
      style={{ display: "block", margin: "0 auto", borderRadius: "50%" }} />
  );
}

// ── Ячейки слова ─────────────────────────────────────────────────────────────
function WwWordDisplay({ mask }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "5px", justifyContent: "center", margin: "12px 0", padding: "0 8px" }}>
      {(mask || []).map((ch, i) =>
        ch === " "
          ? <div key={i} style={{ width: "10px" }} />
          : <div key={i} style={{
              width: "36px", height: "44px",
              background: ch ? "#3dffa0" : "#0d0025",
              border: `2.5px solid ${ch ? "#3dffa0" : "#9b5de555"}`,
              borderRadius: "6px",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontFamily: "'Fredoka One',sans-serif", fontSize: "1.4rem",
              color: ch ? "#000" : "transparent",
              boxShadow: ch ? "0 0 12px #3dffa055" : "inset 0 2px 6px #00000066",
              transition: "all 0.3s",
            }}>{ch || "·"}</div>
      )}
    </div>
  );
}

// ── Host Screen ───────────────────────────────────────────────────────────────
export default function WheelWordHost({
  wwWord, currentPlayer, phase, spinResult, spinKey, spinResultVisible,
  letterResult, wordResult, hint, roundEnd, tick,
  guessedLetters, roundScores, eliminated, players,
}) {
  if (roundEnd) return (
    <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
      <div style={{ fontSize: "3rem", marginBottom: "0.5rem" }}>{roundEnd.solved ? "🎉" : "😔"}</div>
      <h2 style={{
        fontFamily: "'Fredoka One',sans-serif", fontSize: "1.6rem",
        color: roundEnd.solved ? "#3dffa0" : "#f44336", marginBottom: "0.75rem",
      }}>
        {roundEnd.solved ? `${roundEnd.winner} угадал!` : "Никто не угадал"}
      </h2>
      <div style={{
        fontFamily: "'Fredoka One',sans-serif", fontSize: "2.5rem",
        color: "#ffe600", letterSpacing: "0.2em", marginBottom: "1rem",
        textShadow: "3px 3px 0 #ff8c00",
      }}>
        {roundEnd.word}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", justifyContent: "center" }}>
        {(players || []).map(p => (
          <div key={p.name} style={{
            background: "#110825", border: "1.5px solid #9b5de533",
            borderRadius: "0.75rem", padding: "0.3rem 0.8rem",
            fontFamily: "'Nunito',sans-serif", fontSize:"var(--fs-md)", color: "#fff",
          }}>
            {p.name} <span style={{ color: "#ffe600" }}>+{(roundEnd.round_scores || {})[p.name] || 0}</span>
          </div>
        ))}
      </div>
    </div>
  );

  if (!wwWord) return null;

  const spinBannerColor =
    spinResult?.type === "bankrupt" ? "#f44336" :
    spinResult?.type === "skip"     ? "#9C27B0" :
    spinResult?.type === "joker"    ? "#f9a825" : "#3dffa0";

  return (
    <div style={{ width: "100%", maxWidth: "720px", margin: "0 auto", padding: "0.5rem" }}>

      {/* Timer + category */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px", flexWrap: "wrap", gap: "6px" }}>
        {wwWord.category && (
          <span style={{
            background: "#1a0040", border: "1.5px solid #9b5de5",
            borderRadius: "6px", padding: "2px 10px",
            fontFamily: "'Nunito',sans-serif", fontSize:"var(--fs-sm)", color: "#9b5de5",
          }}>
            📂 {wwWord.category}
          </span>
        )}
        <span style={{
          fontFamily: "'Fredoka One',sans-serif", fontSize: "1.8rem",
          color: tick <= 10 ? "#f44336" : "#ffe600",
          textShadow: tick <= 10 ? "0 0 14px #f4433688" : "none",
          transition: "color 0.3s",
        }}>
          ⏱ {tick}с
        </span>
      </div>

      {/* Current player */}
      <p style={{ fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", color: "#FF6B6B", textAlign: "center", margin: "4px 0" }}>
        ▶ Ход: <strong style={{ color: "#fff" }}>{currentPlayer}</strong>
        {phase === "spin" && !spinResult && " — крутит колесо"}
        {phase === "spin" && spinResult && !spinResultVisible && " — 🎡 колесо крутится..."}
        {spinResultVisible && spinResult?.type === "joker" && " — выбирает букву (ДЖОКЕР)"}
        {spinResultVisible && spinResult?.type === "mult" && ` — называет букву (${spinResult.label})`}
      </p>

      {/* Word */}
      <WwWordDisplay mask={wwWord.word_mask} />

      {/* Guessed letters */}
      {(guessedLetters || []).length > 0 && (
        <p style={{ textAlign: "center", fontFamily: "'Nunito',sans-serif", fontSize:"var(--fs-sm)", color: "#555", marginBottom: "6px" }}>
          Уже названы: <strong style={{ color: "#888" }}>{guessedLetters.join(" · ")}</strong>
        </p>
      )}

      {/* Players bar */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", justifyContent: "center", marginBottom: "8px" }}>
        {(players || []).map(p => {
          const active = p.name === currentPlayer;
          const elim   = (eliminated || []).includes(p.name);
          return (
            <div key={p.name} style={{
              background: elim ? "#200000" : active ? "#FF6B6B22" : "#110825",
              border: `2px solid ${elim ? "#f44336" : active ? "#FF6B6B" : "#ffffff11"}`,
              borderRadius: "10px", padding: "3px 10px",
              fontFamily: "'Fredoka One',sans-serif", fontSize:"var(--fs-sm)",
              color: elim ? "#f44336" : active ? "#FF6B6B" : "#aaa",
            }}>
              {elim ? "💀" : active ? "▶" : ""} {p.name}
              {(roundScores || {})[p.name] > 0 && (
                <span style={{ color: "#ffe600", marginLeft: "5px" }}>{roundScores[p.name]}</span>
              )}
            </div>
          );
        })}
      </div>

      {/* Wheel */}
      <WheelSVG spinResult={spinResult} spinKey={spinKey} />

      {/* Spin result banner */}
      {spinResult && spinResultVisible && (
        <div style={{
          textAlign: "center", margin: "8px 0", padding: "6px 12px",
          borderRadius: "12px", background: spinBannerColor + "22",
          border: `2px solid ${spinBannerColor}`,
          fontFamily: "'Fredoka One',sans-serif", fontSize: "1.15rem",
          color: spinBannerColor,
        }}>
          {spinResult.type === "bankrupt" && "💸 БАНКРОТ! Очки раунда сгорают"}
          {spinResult.type === "skip"     && "⏭ ПРОПУСТИ ХОД!"}
          {spinResult.type === "joker"    && "🃏 ДЖОКЕР! Игрок выбирает любую букву"}
          {spinResult.type === "mult"     && `Выпало ${spinResult.label} — ожидаем букву`}
        </div>
      )}

      {/* Letter result */}
      {letterResult && (
        <div style={{ textAlign: "center", fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", margin: "6px 0", color: letterResult.found ? "#3dffa0" : "#f44336" }}>
          {letterResult.joker
            ? (letterResult.found
                ? `🃏 Буква «${letterResult.letter}» открыта (${letterResult.count}×)!`
                : `🃏 «${letterResult.letter}» — нет такой буквы`)
            : letterResult.found
              ? `✅ «${letterResult.letter}» есть! (${letterResult.count}×) +${letterResult.points} очков`
              : `❌ Буквы «${letterResult.letter}» нет — ход переходит`}
        </div>
      )}

      {/* Word result */}
      {wordResult && (
        <div style={{ textAlign: "center", fontFamily: "'Fredoka One',sans-serif", fontSize: "1.1rem", margin: "6px 0", color: wordResult.correct ? "#3dffa0" : "#f44336" }}>
          {wordResult.correct
            ? `🎯 ${wordResult.player} угадал слово! +500 бонус`
            : `💀 ${wordResult.player} ошибся — вылетает из раунда`}
        </div>
      )}

      {/* Hint */}
      {hint && (
        <div style={{
          background: "#1a1400", border: "1.5px solid #ffe60055",
          borderRadius: "10px", padding: "8px 14px", margin: "6px 0",
          fontFamily: "'Nunito',sans-serif", fontSize:"var(--fs-md)",
          color: "#ffe600", textAlign: "center",
        }}>
          💡 {hint.text}
          <span style={{ color: "#555", fontSize:"var(--fs-sm)", marginLeft: "6px" }}>(-{hint.cost} очков)</span>
        </div>
      )}
    </div>
  );
}
